var map = {
	"./README.md": "Hj84",
	"./en": "3NCY",
	"./en.ts": "3NCY",
	"./en/": "LRm5",
	"./en/community": "fudQ",
	"./en/community.ts": "fudQ",
	"./en/documentation": "6skC",
	"./en/documentation.ts": "6skC",
	"./en/head-seo": "Azp4",
	"./en/head-seo.ts": "Azp4",
	"./en/index": "LRm5",
	"./en/index.ts": "LRm5",
	"./en/nav": "Pfhg",
	"./en/nav.ts": "Pfhg",
	"./en/playground": "rvpb",
	"./en/playground.ts": "rvpb",
	"./en/tsconfig": "Pmsi",
	"./en/tsconfig.ts": "Pmsi",
	"./es": "LcQM",
	"./es.ts": "LcQM",
	"./es/": "Q/CX",
	"./es/head-seo": "ZJrW",
	"./es/head-seo.ts": "ZJrW",
	"./es/index": "Q/CX",
	"./es/index.ts": "Q/CX",
	"./es/nav": "cAfB",
	"./es/nav.ts": "cAfB",
	"./es/playground": "WJDZ",
	"./es/playground.ts": "WJDZ",
	"./es/tsconfig": "p9hg",
	"./es/tsconfig.ts": "p9hg",
	"./ja": "Yv0w",
	"./ja.ts": "Yv0w",
	"./ja/playground": "2e90",
	"./ja/playground.ts": "2e90",
	"./vo": "oqfC",
	"./vo.ts": "oqfC",
	"./vo/nav": "QhMr",
	"./vo/nav.ts": "QhMr",
	"./zh": "1q4A",
	"./zh.ts": "1q4A",
	"./zh/": "2D3S",
	"./zh/documentation": "5CsJ",
	"./zh/documentation.ts": "5CsJ",
	"./zh/head-seo": "7nF8",
	"./zh/head-seo.ts": "7nF8",
	"./zh/index": "2D3S",
	"./zh/index.ts": "2D3S",
	"./zh/nav": "J3vH",
	"./zh/nav.ts": "J3vH",
	"./zh/playground": "4Nhz",
	"./zh/playground.ts": "4Nhz",
	"./zh/tsconfig": "KEY/",
	"./zh/tsconfig.ts": "KEY/"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "YWK9";